<template>
  <div class="card">
    <h5 class="card-header bg-primary text-white">Parameters</h5>
    <div class="card-body">
      <form>
        <div class="form-row">
          <div class="col-12 col-md-6 col-lg-4">
            <div class="form-group row">
              <label class="col-4 col-form-label">Reg. Id</label>
              <input type="text" class="col-8 form-control-plaintext" readonly placeholder="---" :disabled="isLoading" v-model="registration.registrationId" />
            </div>
            <div class="form-group row">
              <label class="col-4 col-form-label">Reference #</label>
              <input type="text" class="col-8 form-control-plaintext" readonly placeholder="---" :disabled="isLoading" v-model="referenceNumber" />
            </div>
            <div class="form-group row">
              <label class="col-4 col-form-label">Email</label>
              <input type="text" class="col-8 form-control-plaintext" readonly placeholder="---" :disabled="isLoading" v-model="registration.emailAddress" />
            </div>
            <div class="form-group row">
              <label class="col-4 col-form-label">Type</label>
              <input type="text" class="col-8 form-control-plaintext" readonly placeholder="---" :disabled="isLoading" v-model="registration.testDisplayName" />
            </div>
            <div class="form-group row">
              <label class="col-4 col-form-label">Date</label>
              <input type="text" class="col-8 form-control-plaintext" readonly placeholder="---" :disabled="isLoading" v-model="timestamp" />
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-4">
            <div class="form-group row">
              <label class="col-6 col-form-label">Facility/Store</label>
              <input
                type="text"
                class="col-6 form-control-plaintext"
                readonly
                placeholder="---"
                :disabled="isLoading"
                v-model="registration.facilityDisplayName"
              />
            </div>
            <div class="form-group row">
              <label class="col-6 col-form-label">Function/District</label>
              <input
                type="text"
                class="col-6 form-control-plaintext"
                readonly
                placeholder="---"
                :disabled="isLoading"
                v-model="registration.functionDisplayName"
              />
            </div>
            <div class="form-group row">
              <label class="col-6 col-form-label">Region</label>
              <input
                type="text"
                class="col-6 form-control-plaintext"
                readonly
                placeholder="---"
                :disabled="isLoading"
                v-model="registration.regionDisplayName"
              />
            </div>
            <div class="form-group row">
              <label class="col-6 col-form-label">Company/Division</label>
              <input
                type="text"
                class="col-6 form-control-plaintext"
                readonly
                placeholder="---"
                :disabled="isLoading"
                v-model="registration.companyDisplayName"
              />
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-4">
            <div class="form-group row">
              <label class="col-5 col-form-label">Country</label>
              <input
                type="text"
                class="col-7 form-control-plaintext"
                readonly
                placeholder="---"
                :disabled="isLoading"
                v-model="registration.countryDisplayName"
              />
            </div>
            <div class="form-group row">
              <label class="col-5 col-form-label">State</label>
              <input
                type="text"
                class="col-7 form-control-plaintext"
                readonly
                placeholder="---"
                :disabled="isLoading"
                v-model="registration.stateDisplayName"
              />
            </div>
            <div class="form-group row">
              <label class="col-5 col-form-label">Language</label>
              <input
                type="text"
                class="col-7 form-control-plaintext"
                readonly
                placeholder="---"
                :disabled="isLoading"
                v-model="registration.languageDisplayName"
              />
            </div>
            <div class="form-group row">
              <label class="col-5 col-form-label">Extended Time</label>
              <input type="text" class="col-7 form-control-plaintext" readonly placeholder="---" :disabled="isLoading" v-model="extendedTime" />
            </div>
          </div>

          <div class="col-12" v-if="extendedTime === 'Yes'">
            <div class="form-group row">
              <label class="col-5 col-md-3 col-lg-2 col-form-label">Extended Reason</label>
              <textarea
                :rows="textAreaRows"
                class="col-5 col-md-9 col-lg-10 form-control-plaintext"
                readonly
                placeholder="---"
                :disabled="isLoading"
                v-model="registration.extendedTimeReason"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import formatter from "@/utils/formatter";

export default {
  props: {
    isLoading: Boolean,
    report: Object,
  },
  computed: {
    registration() {
      return this.report ? this.report.registration || {} : {};
    },
    referenceNumber() {
      return this.report ? this.report.referenceNumber : null;
    },
    timestamp() {
      return formatter.date.default(this.registration.timestamp);
    },
    extendedTime() {
      return this.registration ? (this.registration.extendedTime ? "Yes" : "No") : null;
    },
    textAreaRows() {
      return this.registration && this.registration.extendedTimeReason && this.registration.extendedTimeReason.length > 0 ? 3 : 1;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/base.scss";

.form-group {
  margin-bottom: 0;
}

input[readonly="readonly"] {
  outline: 0px transparent;
}

textarea[readonly="readonly"] {
  outline: 0px transparent;
}
</style>
